import React from 'react';
import { FlatList } from 'react-native';
import { isBlank } from '../../utils/BooleanUtility';
import { LAYOUT } from '../../config/Constants';
import RoutineRailList from './RoutineRailList';
import RoutineVerticalList from './RoutineVerticalList';

const Component = {
  list: RoutineVerticalList,
  rail: RoutineRailList,
};

const RoutineList = (props) => {
  const { itemData = [], myRewardPoints = '', isRoutineActive = false } = props; // Ensure `itemData` is correctly passed as a prop
  // Function to render individual items
  const getComponent = ({ item, index }) => {
    const {
      display = '',
      commonActivityItems = [],
      title = '',
      subtitle = '',
    } = item;
    if (isBlank(item)) return null; // Skip rendering if the item is blank

    const ContainerComponent = Component[display]; // Select the correct component
    // Render the component with appropriate props
    return (
      <ContainerComponent
        itemData={commonActivityItems}
        title={title}
        subtitle={subtitle}
        myRewardPoints={myRewardPoints}
        isRoutineActive={isRoutineActive}
      />
    );
  };

  // Key extractor for FlatList
  const keyExtractor = (item, index) => `${item.id}_${index}_routine`;

  return (
    <FlatList
      data={itemData}
      renderItem={getComponent}
      keyExtractor={keyExtractor}
      initialNumToRender={5}
    />
  );
};

export default RoutineList;
